import React from "react";
import { Button } from "react-bootstrap";
import { connect } from "react-redux";
import Icon from "components/Icons/Icon";

class DeleteSites extends React.Component {
  render() {
    const { darkMode, handleDeleteSites } = this.props

    return (
      <>
        <Button
          variant={darkMode ? 'primary' : 'light'}
          type="submit"
          className="action-button"
          id="delete-button"
          onClick={handleDeleteSites}
        >
          <Icon className="fas fa-trash-alt icons" />
          <span className="action-text">Delete Sites</span>
        </Button>
      </>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    darkMode: state.app.darkMode,
  };
};
export default connect(mapStateToProps)(DeleteSites);
